var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOsX = function SvgOsX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247.574 247.574",
    style: {
      enableBackground: "new 0 0 247.574 247.574"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.787.001C55.53.001 0 55.531 0 123.787s55.53 123.786 123.787 123.786 123.787-55.53 123.787-123.786S192.044.001 123.787.001zm0 232.572C63.802 232.573 15 183.772 15 123.787S63.802 15.001 123.787 15.001s108.787 48.801 108.787 108.786-48.801 108.786-108.787 108.786z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m133.047 123.786 42.316-58.429a7.5 7.5 0 1 0-12.149-8.799L123.787 111l-39.43-54.441a7.5 7.5 0 0 0-10.474-1.675 7.502 7.502 0 0 0-1.675 10.474l42.317 58.429-42.317 58.43a7.5 7.5 0 1 0 12.149 8.799l39.43-54.442 39.43 54.442a7.49 7.49 0 0 0 6.08 3.101 7.5 7.5 0 0 0 6.068-11.9l-42.318-58.431z"
  })));
};
export default SvgOsX;